import React from 'react';
import { useAuth } from '../context/AuthContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import ComingSoonBanner from '../components/ComingSoonBanner';

const Voice = () => {
  const { user } = useAuth();

  return (
    <div className="font-display bg-background-light dark:bg-background-dark min-h-screen">
      <div className="px-4 sm:px-10 md:px-20 lg:px-40">
        <Header />
        
        <div className="py-8">
          <div className="mb-8">
            <h1 className="text-3xl font-bold text-gray-900 dark:text-white mb-2">
              🎙️ Módulo de Voz
            </h1>
            <p className="text-gray-600 dark:text-gray-300">
              Genera voz, transcribe audio y clona voces con IA avanzada
            </p>
          </div>

          <ComingSoonBanner
            title="Módulo de Voz - Próximamente"
            description="Este módulo está siendo configurado con las últimas tecnologías de IA de voz. Pronto podrás generar voz realista (Text-to-Speech), transcribir audio (Speech-to-Text) y clonar voces con calidad profesional."
            estimatedDate="Enero 2025"
          />

          <div className="bg-white dark:bg-[#1a2530] rounded-xl p-6 shadow-sm">
            <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">
              Características Próximas
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🗣️ Text-to-Speech</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Convierte texto a voz natural en múltiples idiomas y voces
                </p>
              </div>
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">📝 Speech-to-Text</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Transcribe audio a texto con alta precisión
                </p>
              </div>
              <div className="p-4 border border-gray-200 dark:border-gray-700 rounded-lg">
                <h3 className="font-semibold text-gray-900 dark:text-white mb-2">🎭 Clonación de Voz</h3>
                <p className="text-sm text-gray-600 dark:text-gray-400">
                  Clona voces con IA para contenido personalizado
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <Footer />
      </div>
    </div>
  );
};

export default Voice;